enum LanguageEnum {
  English = 0,
  Spanish = 1
}

export default LanguageEnum;
